<template>
  <div>
    <div class="uk-card uk-card-default uk-card-body uk-card-small">
      <img :src="product.productData.proofImage" />
      <div class="uk-margin-small">
        <select class="uk-select" v-model="product.productData.productType">
          <option v-for="product in allProducts" :key="product.productType">{{
            product.productType
          }}</option>
        </select>
      </div>
      <div
        v-for="alert in settings.alertsCollection.items"
        :key="alert.keyword"
        class="uk-margin-small"
      >
        <label v-if="alert.keyword == 'hidden'">
          <input
            v-model="product.productData.hidden"
            class="uk-checkbox"
            type="checkbox"
          />
          {{ alert.alertName }}
        </label>
        <label v-else>
          <input
            v-model="product.productData.alerts[alert.keyword]"
            class="uk-checkbox"
            type="checkbox"
          />
          {{ alert.alertName }}
        </label>
      </div>
      <div class="uk-margin-small">
        <textarea
          class="uk-textarea"
          rows="2"
          placeholder="Custom notes"
          v-model="product.productData.customNotes"
        ></textarea>
      </div>
      <p class="uk-margin-small">ID: {{ product.productData.proofID }}</p>
      <p class="uk-margin-small">{{ product.productData.fileName }}</p>
      <p class="uk-margin-small">
        {{ product.productData.created.seconds | moment("MM/DD/YYYY") }}
      </p>
      <button
        class="uk-button uk-button-danger uk-width-1-1 uk-margin-small-top"
        @click="deleteProduct"
      >
        Delete
      </button>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import firebase from "firebase";

export default {
  name: "ProductAdmin",
  methods: {
    deleteProduct() {
      var self = this;
      self.$emit("delete-product", self.product.productId);
    }
  },
  watch: {},
  mounted: function() {},
  components: {},
  props: ["product", "settings", "allProducts"],
  filters: {
    capitalize: function(value) {
      if (!value) return "";

      return _.startCase(value);
    }
  }
};
</script>

<style type="text/css">
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminProduct.vue